import {
  Form,
  FormElementRef,
  FormFetcher,
  FormInput,
  FormSubmitter,
  SelectInput,
  SubmitButton,
  TablePageLayout,
} from '@kirz/mui-admin';
import SaveIcon from '@mui/icons-material/Save';
import React, { useContext, useRef } from 'react';

import { UserContext } from 'contexts';
import { SettingsContext } from 'contexts/SettingsContext';

export function LLMSettings() {
  const { user } = useContext(UserContext);
  const { reload: reloadSettings } = useContext(SettingsContext);

  const formRef = useRef<FormElementRef>(null);

  return (
    <TablePageLayout
      title="Настройки LLM"
      actionContent={
        <SubmitButton
          sx={{ ml: 'auto' }}
          variant="contained"
          loadingPosition="start"
          startIcon={<SaveIcon />}
          formRef={formRef}
          activateOnDirty
        >
          Сохранить
        </SubmitButton>
      }
    >
      <FormSubmitter
        source="settings"
        entityId={{ companyId: { _eq: user.companyId } }}
        onSubmit={reloadSettings}
      >
        <FormFetcher
          source="settings"
          entityId={{ companyId: { _eq: user.companyId } }}
        >
          <Form ref={formRef} sx={{ pt: 1 }}>
            <SelectInput
              name="gptModel"
              label="Модель GPT"
              items={[
                { text: 'OpenAI', value: 'openai' },
                { text: 'Yandex', value: 'yandex' },
              ]}
              required
            />
            <FormInput
              name="callTextExtractionGptPrompt"
              label="Краткий пересказ разговора"
              multiline
              minRows={3}
              required
            />
            <FormInput
              name="callSummarizationGptPrompt"
              label="Сильные и слабые стороны разговора"
              multiline
              minRows={3}
              required
            />
            <FormInput
              name="callAnalyzeGptPrompt"
              label="Рекомендации для продавца"
              multiline
              minRows={3}
              required
            />
          </Form>
        </FormFetcher>
      </FormSubmitter>
    </TablePageLayout>
  );
}
